import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberFormat from "react-number-format";
import { tinhNgayTraGocv3 } from "utils/choVayUtils";
import choVayConst, {
  bindKieuLaiSuat,
  bindTypePaid,
} from "constants/choVayConst";
import ConfigConst from "constants/ConfigConst";
import CustomerForm from "../../CustomerForm";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import CauHinhApi from "../../../../../../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";

const ThemMoiTinChap = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    nguonkhachhang,
    postTinChap,
    onHide,
    cauhinh,
    getDetailCustomer,
    themmoitinchap,
    setChoVayEdit,
    phanquyen,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let {
    ConfigTMCD,
    choVayEdit,
    setListPhiKhac,
    postTinChapLoading,
    postTinChapReturn,
    TaiSanTinChap,
  } = themmoitinchap;
  let NoteTaiSan = TaiSanTinChap.Note;
  let AnhTaiSan = TaiSanTinChap.AnhTaiSan;
  let { objConfig } = cauhinh;
  let objConfigSysLoaiTS = ConfigTMCD;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    PhiDongLaiCham,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,

    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    LoaiPhiPhatTatToan,
    LoaiTinhLai,
    MaNhanVien,
  } = choVayEdit;
  let { LinkDinhKem } = props.data;
  IsEditChoVay = !IsEditChoVay;

  const [currentCountTypePaid, setCurrentCountTypePaid] = useState(null);
  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [anhTaiSan, setAnhTaiSan] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [curentNoteTaiSan, setCurentNoteTaiSan] = useState([]);
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [currentCode, setCode] = useState(null);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);

  const [lstLoaiTinhLai, setlstLoaiTinhLai] = useState([]);
  const [isShowKieuTinhLai, setIsShowKieuTinhLai] = useState(false);

  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
    PhiDongLaiCham: PhiDongLaiCham,
    NoteTaiSan: NoteTaiSan,
    Code: Code,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};
  useEffect(() => {
    if (choVayEdit.ChoVayId > 0) {
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);
    }
    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.LaiSuat !== LaiSuat) {
      setValue("LaiSuat", LaiSuat);
      currentChoVay.LaiSuat = LaiSuat;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.KieuLaiSuat !== KieuLaiSuat) {
      setValue("KieuLaiSuat", KieuLaiSuat);
      currentChoVay.KieuLaiSuat = KieuLaiSuat;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.LaiSuat !== LaiSuat ||
      currentChoVay.TypePaid !== TypePaid ||
      currentChoVay.KieuLaiSuat !== KieuLaiSuat
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }

    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon
        );
      }
    }

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon
        );
      }
    }
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isShowKieuTinhLai = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsShowKieuTinhLai.toUpperCase()
          );
          if (isShowKieuTinhLai != null) {
            if (isShowKieuTinhLai.valueConfig === "1") {
              setIsShowKieuTinhLai(true);
            }
          }
        }
      }
    });

    if (ChoVayId > 0 && AnhTaiSan && AnhTaiSan !== anhTaiSan) {
      setAnhTaiSan(AnhTaiSan);
      setImageTaiSans(AnhTaiSan.split(";"));
    }
    if (ChoVayId > 0 && curentNoteTaiSan && curentNoteTaiSan !== NoteTaiSan) {
      setCurentNoteTaiSan(curentNoteTaiSan);
      setValue("NoteTaiSan", NoteTaiSan);
    }
    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
    // if (typeof thongTinCuaHang === "undefined") {
    //   thongTinCuaHangHienTai();
    // }
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onHide(); // Gọi hàm đóng popup
      }
    };

    // Thêm sự kiện lắng nghe khi component được mount
    document.addEventListener("keydown", handleEscape);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]);

  const onChangeAttNumberChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setChoVayEdit(choVayEdit);
  };
  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    choVayEdit.TypePaid = evt.target.value;
    if (!ChoVayId)
      if (evt.target.value === "1") {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoNgay);
        choVayEdit.LaiSuat = ConfigTMCD._laiSuatTinChapCamDoNgay;

        setValue("KieuLaiSuat", ConfigTMCD._selectKyLaiSuatNgay);
        choVayEdit.KieuLaiSuat = ConfigTMCD._selectKyLaiSuatNgay;
      } else {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoThang);
        choVayEdit.LaiSuat = ConfigTMCD._laiSuatTinChapCamDoThang;

        setValue("KieuLaiSuat", ConfigTMCD._selectKyLaiSuatThang);
        choVayEdit.KieuLaiSuat = ConfigTMCD._selectKyLaiSuatThang;
      }
    setChoVayEdit(choVayEdit);
  };
  let { PhanQuyenTinChap } = phanquyen;
  let { chonngaygiaodich, laingay_sudungchoduyet } = PhanQuyenTinChap;
  let { OptionTinhLai, IsTongSoNgay } = objConfig;

  const onSubmit = (dataChoVay) => {
    if (!IsEditChoVay) {
      let x = tinhNgayTraGocv3(
        parseInt(dataChoVay.SoLanTra),
        parseInt(dataChoVay.TongNgayVay),
        parseInt(dataChoVay.CountTypePaid),
        dataChoVay.NgayVay,
        parseInt(dataChoVay.TypePaid),
        1,
        false,
        dataChoVay.NgayTra,
        IsTongSoNgay,
        true
      );
      dataChoVay.TongNgayVay = x.TongSoNgayVay;
      dataChoVay.NgayTra = x.NgayTraGoc;
      dataChoVay.SoLanTra = x.SoLanTra;
    } else {
      dataChoVay.NgayTra = formatDayMonth(NgayTra);
      dataChoVay.NgayVay = formatDayMonth(NgayVay);
      dataChoVay.SoLanTra = SoLanTra;
      dataChoVay.TypePaid = TypePaid;
    }
    dataChoVay.LoaiTinhLai = choVayEdit.LoaiTinhLai;
    dataChoVay.ImageList = imageTaiSans.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");

    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;
    dataChoVay.MaNhanVien = choVayEdit.MaNhanVien;
    postTinChap({
      ChoVay: dataChoVay,
      Customer: dataChoVay.customer,
      IsChoDuyet: laingay_sudungchoduyet,
      IsCopy: choVayEdit.IsCopy ? choVayEdit.IsCopy : false,
    });
  };
  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayTra = (evt) => {
    choVayEdit.NgayTra = evt;
    setChoVayEdit(choVayEdit);
  };
  const onChangePhiKhac = (configId) => (evt) => {
    objListPhiKhac[configId].GiaTri = evt.value;
    setListPhiKhac(objListPhiKhac);
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const closeThemMoi = () => () => {
    getDetailCustomerSuccess({});
    onHide();
  };
  if (postTinChapReturn) {
    getDetailCustomerSuccess({});
    onHide();
  }
  let { autocompleteData } = customer;
  let { combo } = user;
  let { IsGiaHanTuDong, IsSoNgayTatToan } = ConfigTMCD;

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <div
        className={
          "loader loader-default " + (postTinChapLoading ? "is-active" : "")
        }
      ></div>
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {IsCopy ? "Sao chép " : ChoVayId > 0 ? "Thay đổi " : "Thêm mới "} hợp
          đồng tín chấp
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={closeThemMoi()}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <div
        className={
          "loader loader-default " + (postTinChapLoading ? "is-active" : "")
        }
      ></div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body
          style={{ padding: "0px", background: "#F4F5FA !important" }}
        >
          <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse196"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin khách vay</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  role="tabpanel"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                >
                  <CustomerForm
                    customerId={CustomerID}
                    currentForm={currentForm}
                    autocompleteData={autocompleteData}
                    getAutocompleteCustomer={getAutocompleteCustomer}
                    userCombo={combo}
                    comboNguonKhachHang={comboNguonKhachHang}
                    customer={customer}
                    getDetailCustomer={getDetailCustomer}
                    errors={errors}
                    IsEditCustomer={IsEditCustomer}
                    checkEditCustomer={checkEditCustomer}
                    setEnableEditCustomer={setEnableEditCustomer}
                    IsCopy={IsCopy}
                    CodeCuaHang={thongTinCuaHang.Code}
                  ></CustomerForm>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse194"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse194"
                  aria-expanded="true"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin cho vay</h3>
                  </a>
                </div>
                <div
                  id="collapse194"
                  role="tabpanel"
                  aria-labelledby="headingCollapse94"
                  className="card-collapse collapse show"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <input
                          type="hidden"
                          name="ChoVayId"
                          value={ChoVayId}
                          ref={register}
                        ></input>
                        <div className="col-md-12 col-lg-12">
                          <div className="row thongtinchovay-v2">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Ngày vay <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <DateTimePicker
                                onChange={onChangeNgayVay}
                                value={NgayVay}
                                customInputRef={register}
                                readOnly={!chonngaygiaodich || IsEditChoVay}
                                name="NgayVay"
                                customInput={
                                  <input name="NgayVay" ref={register}></input>
                                }
                              ></DateTimePicker>
                            </div>
                            <div className="col-md-4">
                              <TextInputTwoRow
                                labelClass="col-md-2 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-4"
                                wrapperClass="form-group row"
                                labelText="Mã hợp đồng"
                                placeholder="Mã hợp đồng"
                                value={Code}
                                inputProps={{
                                  ref: register,
                                  onChange: onChangeAttNumberChoVay("Code"),
                                  name: "Code",
                                  readOnly: IsEditChoVay,
                                }}
                              ></TextInputTwoRow>
                            </div>
                            <div className="col-md-4">
                              <NumberInput
                                labelClass="col-md-2 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-4"
                                wrapperClass="form-group row"
                                labelText="Tổng tiền vay"
                                starRed="*"
                                placeholder="10,000,000"
                                inputProps={{
                                  name: "Sotienvay",
                                  value: Sotienvay,
                                  onChange:
                                    onChangeAttNumberChoVay("Sotienvay"),
                                  rules: {
                                    required: "Hãy nhập số tiền vay",
                                  },
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                                error={errors.Sotienvay}
                              ></NumberInput>
                            </div>
                            {isShowKieuTinhLai === true && (
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Loại hợp đồng{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <br />
                                <select
                                  class="form-control input-sm"
                                  onChange={onChangeAttTextChoVay(
                                    "LoaiTinhLai"
                                  )}
                                  value={LoaiTinhLai}
                                  readOnly={IsEditChoVay}
                                >
                                  <option value="1">Hợp đồng thường</option>
                                  <option value="2">Trả gốc lãi</option>
                                  <option value="3">
                                    Trả gốc lãi Liên Kim
                                  </option>
                                </select>
                              </div>
                            )}
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Kỳ đóng lãi{" "}
                                <span className="canh-bao-red">*</span>
                                <PopoversBootrap
                                  contentText="10 ngày/tháng đóng lãi 1 lần thì điền số 10"
                                  titleText=""
                                  trigger={["hover", "focus"]}
                                  placement={"top"}
                                >
                                  <i className="la la-question-circle tool-comment"></i>
                                </PopoversBootrap>
                              </label>
                              <br />
                              <div class="row">
                                <div
                                  className="col-md-7"
                                  style={{ paddingRight: "0px" }}
                                >
                                  <Controller
                                    name="CountTypePaid"
                                    rules={{
                                      required: "Hãy nhập kỳ đóng lãi",
                                    }}
                                    control={control}
                                    defaultValue={CountTypePaid}
                                    className="form-control left input-sm"
                                    as={NumberFormat}
                                    placeholder="5"
                                    readOnly={IsEditChoVay}
                                  />
                                  <span className="canh-bao-red">
                                    {errors.CountTypePaid &&
                                      errors.CountTypePaid.message}
                                  </span>
                                </div>
                                <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <select
                                    name="TypePaid"
                                    ref={register}
                                    className="form-control right  input-sm select-v2"
                                    onChange={onChangeTypePaid()}
                                    value={TypePaid}
                                    defaultValue={TypePaid}
                                    readOnly={IsEditChoVay}
                                  >
                                    {bindTypePaid(
                                      objConfigSysLoaiTS,
                                      LoaiTinhLai
                                    )}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12"></div>
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Lãi suất <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <div class="row">
                                <div
                                  className={`${
                                    parseFloat(TypePaid) !== 3
                                      ? "col-md-7 pad-right-0"
                                      : "col-md-12"
                                  }`}
                                >
                                  <Controller
                                    name="LaiSuat"
                                    rules={{
                                      required: "Hãy nhập lãi suất",
                                    }}
                                    control={control}
                                    readOnly={IsEditChoVay}
                                    defaultValue={LaiSuat}
                                    className={` form-control input-sm ${
                                      parseFloat(TypePaid) !== 3 ? "left" : ""
                                    }`}
                                    // onChange, onBlur, value, name, ref inejcted to the component
                                    as={NumberFormat}
                                    placeholder={
                                      parseFloat(TypePaid) === 3
                                        ? "%"
                                        : choVayConst.KieuLaiSuatPlaceholder[
                                            KieuLaiSuat
                                          ]
                                    }
                                  />
                                  <span className="canh-bao-red">
                                    {errors.LaiSuat && errors.LaiSuat.message}
                                  </span>
                                </div>
                                <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  {parseFloat(TypePaid) !== 3 && (
                                    <select
                                      name="KieuLaiSuat"
                                      ref={register}
                                      className="form-control  right input-sm select-v2"
                                      onChange={onChangeAttTextChoVay(
                                        "KieuLaiSuat"
                                      )}
                                      value={KieuLaiSuat}
                                      defaultValue={KieuLaiSuat}
                                      disabled={IsEditChoVay}
                                    >
                                      {bindKieuLaiSuat(
                                        objConfigSysLoaiTS,
                                        TypePaid,
                                        LoaiTinhLai
                                      )}
                                    </select>
                                  )}
                                </div>
                              </div>
                            </div>
                            {OptionTinhLai === ConfigConst.ShowDate ? (
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Ngày trả{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <fieldset>
                                  <div className="input-group input-icon">
                                    <DateTimePicker
                                      onChange={onChangeNgayTra}
                                      value={NgayTra}
                                      name="NgayTra"
                                      customInputRef={register({
                                        required: "Hãy nhập ngày trả",
                                      })}
                                      readOnly={IsEditChoVay}
                                      customInput={
                                        <input
                                          name="NgayTra"
                                          ref={register}
                                        ></input>
                                      }
                                    ></DateTimePicker>
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-calendar"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <span className="canh-bao-red">
                                    {errors.NgayTra && errors.NgayTra.message}
                                  </span>
                                </fieldset>
                              </div>
                            ) : IsTongSoNgay ? (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Số ngày trả lãi"
                                  starRed="*"
                                  placeholder="12"
                                  inputProps={{
                                    name: "TongNgayVay",
                                    value: TongNgayVay,
                                    onChange:
                                      onChangeAttNumberChoVay("TongNgayVay"),
                                    rules: {
                                      required: "Hãy nhập tổng số ngày trả",
                                    },
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                  error={errors.TongNgayVay}
                                ></NumberInput>
                              </div>
                            ) : (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="col-md-2 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Số lần trả"
                                  toolTip
                                  textToolTip="Số kỳ trả 10 kỳ điền số 10"
                                  starRed="*"
                                  placeholder="12"
                                  inputProps={{
                                    name: "SoLanTra",
                                    value: SoLanTra,
                                    onChange:
                                      onChangeAttNumberChoVay("SoLanTra"),
                                    rules: {
                                      required: "Hãy nhập số lần trả",
                                    },
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                  error={errors.SoLanTra}
                                ></NumberInput>
                              </div>
                            )}
                            <div className="col-md-12"></div>
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Lãi suất <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <div class="row">
                                <div
                                  className={`${
                                    parseFloat(TypePaid) !== 3
                                      ? "col-md-7 pad-right-0"
                                      : "col-md-12"
                                  }`}
                                >
                                  <Controller
                                    name="LaiSuat"
                                    rules={{
                                      required: "Hãy nhập lãi suất",
                                    }}
                                    control={control}
                                    readOnly={IsEditChoVay}
                                    defaultValue={LaiSuat}
                                    className={` form-control input-sm ${
                                      parseFloat(TypePaid) !== 3 ? "left" : ""
                                    }`}
                                    // onChange, onBlur, value, name, ref inejcted to the component
                                    as={NumberFormat}
                                    placeholder={
                                      parseFloat(TypePaid) === 3
                                        ? "%"
                                        : choVayConst.KieuLaiSuatPlaceholder[
                                            KieuLaiSuat
                                          ]
                                    }
                                  />
                                  <span className="canh-bao-red">
                                    {errors.LaiSuat && errors.LaiSuat.message}
                                  </span>
                                </div>
                                <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  {parseFloat(TypePaid) !== 3 && (
                                    <select
                                      name="KieuLaiSuat"
                                      ref={register}
                                      className="form-control  right input-sm select-v2"
                                      onChange={onChangeAttTextChoVay(
                                        "KieuLaiSuat"
                                      )}
                                      value={KieuLaiSuat}
                                      defaultValue={KieuLaiSuat}
                                      disabled={IsEditChoVay}
                                    >
                                      {bindKieuLaiSuat(
                                        objConfigSysLoaiTS,
                                        TypePaid,
                                        LoaiTinhLai
                                      )}
                                    </select>
                                  )}
                                </div>
                              </div>
                            </div>
                            {OptionTinhLai === ConfigConst.ShowDate ? (
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Ngày trả{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <fieldset>
                                  <div className="input-group input-icon">
                                    <DateTimePicker
                                      onChange={onChangeNgayTra}
                                      value={NgayTra}
                                      name="NgayTra"
                                      customInputRef={register({
                                        required: "Hãy nhập ngày trả",
                                      })}
                                      readOnly={IsEditChoVay}
                                      customInput={
                                        <input
                                          name="NgayTra"
                                          ref={register}
                                        ></input>
                                      }
                                    ></DateTimePicker>
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-calendar"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <span className="canh-bao-red">
                                    {errors.NgayTra && errors.NgayTra.message}
                                  </span>
                                </fieldset>
                              </div>
                            ) : IsTongSoNgay ? (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Số ngày trả lãi"
                                  starRed="*"
                                  placeholder="12"
                                  inputProps={{
                                    name: "TongNgayVay",
                                    value: TongNgayVay,
                                    onChange:
                                      onChangeAttNumberChoVay("TongNgayVay"),
                                    rules: {
                                      required: "Hãy nhập tổng số ngày trả",
                                    },
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                  error={errors.TongNgayVay}
                                ></NumberInput>
                              </div>
                            ) : (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="col-md-2 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Số lần trả"
                                  toolTip
                                  textToolTip="Số kỳ trả 10 kỳ điền số 10"
                                  starRed="*"
                                  placeholder="12"
                                  inputProps={{
                                    name: "SoLanTra",
                                    value: SoLanTra,
                                    onChange:
                                      onChangeAttNumberChoVay("SoLanTra"),
                                    rules: {
                                      required: "Hãy nhập số lần trả",
                                    },
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                  error={errors.SoLanTra}
                                ></NumberInput>
                              </div>
                            )}
                            <div className="col-md-12"></div>
                            <div
                              className={
                                "col-md-4" +
                                (objConfigSysLoaiTS._allBeforeAfterTinChapCamDo
                                  ? ""
                                  : " hidden")
                              }
                            >
                              <label className="label-control color7-bold">
                                Kiểu thu lãi{" "}
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <select
                                name="BeforeAfter"
                                className="form-control input-sm select-v2"
                                ref={register}
                                value={BeforeAfter}
                                onChange={onChangeAttTextChoVay("BeforeAfter")}
                                disabled={IsEditChoVay}
                              >
                                <option value="1">Sau</option>
                                <option value="2">Trước</option>
                              </select>
                            </div>

                            {IsSoNgayTatToan && (
                              <NumberInput
                                labelClass="col-md-2 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-4"
                                wrapperClass="form-group row"
                                labelText="Làm tròn tiền/ngày"
                                placeholder="1"
                                inputProps={{
                                  name: "SoNgayTinhLaiTruocHan",
                                  value: SoNgayToiThieu,
                                  onChange:
                                    onChangeAttNumberChoVay("SoNgayToiThieu"),
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                              ></NumberInput>
                            )}
                            <div className="col-md-12"></div>
                            {IsGiaHanTuDong && (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="label-control color7-bold"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Thêm ngày quá hạn"
                                  placeholder="1"
                                  inputProps={{
                                    name: "SoNgayGiaHanTuDong",
                                    value: SoNgayGiaHan,
                                    onChange:
                                      onChangeAttNumberChoVay("SoNgayGiaHan"),
                                    control: control,
                                    disabled: IsEditChoVay,
                                  }}
                                ></NumberInput>
                              </div>
                            )}
                            {props.SuDungPhiPhat_DongLai_Cham && (
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="label-control color7-bold"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Phí phạt đóng lãi chậm"
                                  inputProps={{
                                    name: "PhiDongLaiCham",
                                    value: PhiDongLaiCham,
                                    onChange:
                                      onChangeAttNumberChoVay("PhiDongLaiCham"),
                                    control: control,
                                    readOnly: IsEditChoVay,
                                    placeholder: "%",
                                  }}
                                ></NumberInput>{" "}
                              </div>
                            )}
                            <div className="col-md-12"></div>
                            {props.SuDungPhiPhat_DongLai_TatToan && (
                              <>
                                <div className="col-md-4">
                                  <NumberInput
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-6"
                                    labelText="Phạt chậm đóng lãi"
                                    wrapperClass="form-group row"
                                    inputProps={{
                                      name: "PhiPhatTraLai",
                                      value: PhiPhatTraLai,
                                      onChange:
                                        onChangeAttNumberChoVay(
                                          "PhiPhatTraLai"
                                        ),
                                      control: control,
                                      readOnly: IsEditChoVay,
                                    }}
                                  ></NumberInput>
                                </div>
                                <div className="col-md-4 radio-button-nhap-tien">
                                  <label className="custom-radio">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTraLai"
                                      onChange={onChangeLoaiPhiPhatTraLai(1)}
                                      checked={
                                        intLoaiPhiPhatTraLai === 1
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập tiền
                                  </label>
                                  <label className="custom-radio radio-button-nhap-phan-tram">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTraLai"
                                      onChange={onChangeLoaiPhiPhatTraLai(2)}
                                      checked={
                                        intLoaiPhiPhatTraLai === 2
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập %
                                  </label>
                                </div>
                              </>
                            )}
                            <div className="col-md-12"></div>
                            {props.SuDungTatToanSom && (
                              <>
                                <div className="col-md-4">
                                  <NumberInput
                                    labelClass="col-md-6 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-6"
                                    labelText="Phạt tất toán sớm"
                                    wrapperClass="form-group row"
                                    inputProps={{
                                      name: "PhiPhatTatToan",
                                      value: PhiPhatTatToan,
                                      onChange:
                                        onChangeAttNumberChoVay(
                                          "PhiPhatTatToan"
                                        ),
                                      control: control,
                                      readOnly: IsEditChoVay,
                                    }}
                                  ></NumberInput>
                                </div>
                                <div className="col-md-4 radio-button-nhap-tien">
                                  <label className="custom-radio">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTatToan"
                                      onChange={onChangeLoaiPhiPhatTatToan(1)}
                                      checked={
                                        intLoaiPhiPhatTatToan === 1
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập tiền
                                  </label>
                                  <label className="custom-radio radio-button-nhap-phan-tram">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTatToan"
                                      onChange={onChangeLoaiPhiPhatTatToan(2)}
                                      checked={
                                        intLoaiPhiPhatTatToan === 2
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập %
                                  </label>
                                </div>
                              </>
                            )}
                            <div className="col-md-12"></div>
                            {props.SuDungCongTacVienNhanVien && (
                              <div className="col-md-4">
                                <TextInputTwoRow
                                  labelClass="col-md-2 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-4"
                                  wrapperClass="form-group row"
                                  labelText="Mã nhân viên"
                                  placeholder="Mã nhân viên"
                                  inputProps={{
                                    name: "MaNhanVien",
                                    onChange:
                                      onChangeAttTextChoVay("MaNhanVien"),
                                    value: MaNhanVien,
                                  }}
                                ></TextInputTwoRow>
                              </div>
                            )}

                            <div className="col-md-12">
                              <label className="label-control color7-bold">
                                Ghi chú
                              </label>
                              <textarea
                                rows="1"
                                style={{ minHeight: "80px" }}
                                className="form-control input-sm"
                                name="Note"
                                placeholder=""
                                value={Note}
                                onChange={onChangeAttTextChoVay("Note")}
                                ref={register}
                                disabled={IsEditChoVay}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse19412"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse19412"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Các loại phí</h3>
                  </a>
                </div>
                <div
                  id="collapse19412"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          {objListPhiKhac &&
                            objListPhiKhac.map((item, idx) => (
                              <div key={"phiKhac" + idx}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      wrapperClass="form-group row"
                                      labelText={item.TenPhiKhac}
                                      inputProps={{
                                        name: "ListPhiKhac[" + idx + "].GiaTri",
                                        value: objListPhiKhac[idx].GiaTri,
                                        onChange: onChangePhiKhac(idx),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-6">
                                    {item.LoaiPhiKhac == 1 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : item.LoaiPhiKhac == 2 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập Tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="1"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 1
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                1
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="2"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 2
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                2
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <input
                                  type="hidden"
                                  name={
                                    "ListPhiKhac[" + idx + "].ConfigPhiKhacId"
                                  }
                                  value={item.ConfigPhiKhacId}
                                  ref={register}
                                />
                                <input
                                  type="hidden"
                                  name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                                  value={item.LoaiPhiKhac}
                                  ref={register}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {objListPhiKhacHangKy != undefined &&
                    objListPhiKhacHangKy.length > 0 && (
                      <>
                        <div
                          id="headingCollapse194121"
                          className="card-header  mt-1"
                          data-toggle="collapse"
                          href="#collapse194121"
                          aria-expanded="false"
                          aria-controls="collapse1941"
                        >
                          <a
                            className="card-title lead info collapsed"
                            href={() => false}
                          >
                            <h3>Các loại phí hàng kỳ</h3>
                          </a>
                        </div>
                        <div
                          id="collapse194121"
                          role="tabpanel"
                          aria-labelledby="headingCollapse194121"
                          className="card-collapse collapse"
                        >
                          <div className="card-content">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-12 col-lg-12">
                                  {objListPhiKhacHangKy &&
                                    objListPhiKhacHangKy.map((item, idx) => (
                                      <div key={"phiKhacHangKy" + idx}>
                                        <div className="row">
                                          <div className="col-md-6">
                                            <NumberInput
                                              labelClass="col-md-6 label-control"
                                              inputClass="form-control input-sm"
                                              inputWrapClass="col-md-6"
                                              wrapperClass="form-group row"
                                              labelText={item.TenPhiKhacHangKy}
                                              inputProps={{
                                                name:
                                                  "ListPhiKhacHangKy[" +
                                                  idx +
                                                  "].GiaTri",
                                                value:
                                                  objListPhiKhacHangKy[idx]
                                                    .GiaTri,
                                                onChange:
                                                  onChangePhiKhacHangKy(idx),
                                                control: control,
                                              }}
                                            ></NumberInput>
                                          </div>
                                          <div className="col-md-6">
                                            {item.LoaiPhiKhacHangKy == 1 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : item.LoaiPhiKhacHangKy == 2 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>
                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="1"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        1
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        1
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="2"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        2
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        2
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].ConfigPhiKhacHangKyId"
                                          }
                                          value={item.ConfigPhiKhacHangKyId}
                                          ref={register}
                                        />
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].LoaiPhiKhacHangKy"
                                          }
                                          value={item.LoaiPhiKhacHangKy}
                                          ref={register}
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse19412"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse19413"
                  aria-expanded="false"
                  aria-controls="collapse19413"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Bổ sung giấy tờ tín chấp vay</h3>
                  </a>
                </div>
                <div
                  id="collapse19413"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <label class="col-md-4 color7-bold">
                          Giấy tờ tín chấp
                        </label>
                        <br />
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="1 CMT + 1 GPLX"
                            name="NoteTaiSan"
                            ref={register}
                            readOnly={IsEditChoVay}
                          />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12">
                          <UploadMultiFile
                            Files={imageTaiSans}
                            onChange={setImageTaiSans}
                            Code={thongTinCuaHang.Code}
                          ></UploadMultiFile>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191191"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Đính kèm file</h3>
                  </a>
                </div>
                <div
                  id="collapse191191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          <UploadMultiFile1
                            Files={fileDinhKems}
                            onChange={setFileDinhKems}
                            Code={thongTinCuaHang.Code}
                          ></UploadMultiFile1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
     
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <button className="btn btn-new-main btn-checknew" type="submit">
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            {laingay_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
          </button>

          {/* {showButtonIn && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inHopDong(choVayEdit)}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In hợp đồng
            </button>
          )}

          {showButtonInPhieuThu && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inPhieuThu(ThuChiId)}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In phiếu thu
            </button>
          )} */}

          <button
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={closeThemMoi()}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default ThemMoiTinChap;
